import { Button } from "antd";

const Board = ({ onReset, clear_text }) => {
  const handleSearch = () => {
    if (onReset) {
      onReset();
    }
  };

  return (
    <>
      <Button type='link' className='buttonReset' onClick={handleSearch}>
        {clear_text || "Reset"}
      </Button>
    </>
  );
};

export default Board;
